import { AllocationRule } from '../allocations';
import { CurrencyRateDetails } from '../transaction';
import { CurrencyCode } from '../vehicle';

export enum PartialRealisationAllocationLogic {
  ProRata = 'proRata',
  FIFO = 'fifo',
  LIFO = 'lifo',
  Manual = 'manual',
}

export enum ConsiderationType {
  CashAndWithholdingTax = 'cashAndWithholdingTax',
  Equity = 'equity',
}

export enum ConsiderationAllocationLogic {
  ProRata = 'proRata',
  Manual = 'manual',
}

export enum RealisationTypes {
  RealisationCreated = 'realisationCreated',
}

export enum RealisationTransactionSubType {
  CashProceeds = 'cashProceeds',
  EscrowProceeds = 'escrowProceeds',
  SaleOfInvestment = 'saleOfInvestment',
  RealisedGain = 'realisedGain',
  RealisedGainFX = 'realisedGainFX',
  RealisedLoss = 'realisedLoss',
  RealisedLossFX = 'realisedLossFX',
  WithholdingTax = 'withholdingTax',
  UnrealisedGainsUnwind = 'unrealisedGainsUnwind',
  UnrealisedLossesUnwind = 'unrealisedLossesUnwind',
}

export enum ConsiderationTypeHoldingClassTypes {
  LcyHoldingClass = 'LcyHoldingClass',
  NonLcyConsiderationNonLcyHoldingClass = 'NonLcyConsiderationNonLcyHoldingClass',
  LcyConsiderationForNonLcyHoldingClass = 'LcyConsiderationForNonLcyHoldingClass',
  ThreeCYNonLcyConsiderationNonLcyHoldingClass = 'ThreeCYNonLcyConsiderationNonLcyHoldingClass',
}

export interface InvestorAllocation {
  holdingClassId: string;
  investmentId: string;
  commitmentId: string;
  investorLabel: string;
  allocationPercentage: number;
  originalAllocationPercentage: number;
  allocationType: AllocationRule;
  receivedConsiderationTcy: number;
  earnoutConsiderationTcy: number;
  escrowConsiderationTcy: number;
  withholdingTaxPayableTcy: number;
  unitsAllocated: number;
}

export type HoldingClassRealisation = {
  holdingClassId: string;
  name: string;
  unitsSold?: number;
  cashConsiderationAmounts?: {
    receivedConsiderationPerUnit?: number;
    receivedConsiderationTotal?: number;
    escrowConsiderationPerUnit?: number;
    escrowConsiderationTotal?: number;
    earnoutConsiderationPerUnit?: number;
    earnoutConsiderationTotal?: number;
    withholdingTaxPayable?: number;
  };
  unitsAllocationPerInvestment?: Array<{
    investmentId: string;
    totalInvestmentAmountTcy: number;
    totalInvestmentAmountLcy: number | null | undefined;
    totalInvestmentNumberOfUnits: number;
    currencyRate: CurrencyRateDetails;
    holdingClassId: string;
    name: string;
    allocatedUnits: number;
    date: Date;
    currentNumberOfUnits: number;
    totalNumberOfUnits: number;
    currency: CurrencyCode;
    investmentAmountTcy: number;
    investmentAmountLcy: number;
    unitPriceTcy: number;
    currentUnrealisedValue: number;
    currentMOIC: string;
    allocations?: Array<{
      commitmentId: string;
      commitment: {
        totalCommitmentLcy: number;
      };
      allocationAmountTcy: number;
      allocationPercentage: number;
      excludeFromAllocation: boolean;
      investorLabel: string;
      withholdingTaxExempt?: boolean;
    }>;
  }>;
};

export type WithholdingTaxAllocation = {
  commitmentId: string;
  totalCommitmentLcy: number;
  withholdingTaxExempt: boolean;
  investorName: string;
};

export type MinimumHoldingClassRealisation = {
  unitsSold?: number;
  name?: string;
  holdingClassId: string;
  cashConsiderationAmounts?: {
    receivedConsiderationPerUnit?: number;
    receivedConsiderationTotal?: number;
    escrowConsiderationPerUnit?: number;
    escrowConsiderationTotal?: number;
    earnoutConsiderationPerUnit?: number;
    earnoutConsiderationTotal?: number;
    withholdingTaxPayable?: number;
  };
  unitsAllocationPerInvestment?: Array<{
    currencyRate?: CurrencyRateDetails;
    investmentId: string;
    holdingClassId: string;
    allocatedUnits: number;
    date: Date;
    allocations?: Array<{
      commitmentId: string;
      allocationPercentage: number;
      investorLabel: string;
      withholdingTaxExempt?: boolean;
    }>;
  }>;
};

export type InvestmentAllocation = {
  holdingClassId: string;
  commitmentId: string;
  withholdingTaxPayable: number;
  investmentId: string;
  allocationPercentage: number;
  allocationType: AllocationRule;
  investorName: string;
  investmentDate: Date;
  holdingClassName: string;
  unitsAllocated: number;
  originalAllocationPercentage: number;
  receivedConsideration: number;
  earnoutConsideration: number;
  escrowConsideration: number;
  withholdingTaxExempt?: boolean;
};
